import styled from '@emotion/styled';

export const ContentButton = styled.div`
  display: flex;
  margin-top: 20px;
  top: 0px;
  left: 0px;
  position: absolute;
  height: 20px;
  width: 200px;
  font-style: normal;
  font-weight: bold;
  line-height: 20px;
  color: #6fcaff;
`;

export const Content = styled.div`
  display: flex;
  height: 90vh;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  margin: 0 auto;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-items: center;

  a {
    position: absolute;
    margin: 0px;
    text-decoration: none;
    height: 20px;
    width: 100px;
  }

  h2 {
    font-weight: bold;
    font-size: 3rem;
  }
  p {
    margin-top: 1rem;
    font-style: normal;
    font-weight: normal;
    font-size: 1.2rem;

    margin-bottom: 5rem;
    color: #000000;
  }

  form {
    width: 100%;
    max-width: 450px;
  }
`;

export const ComeBack = styled.div`
  position: absolute;
  top: 0px;
  left: 20px;
  font-size: 1rem;
`;

export const Back = styled.div`
  display: flex;
  flex-direction: column;
  width: 30px;
  height: 20px;
  svg {
    fill: #6fcaff;
  }
  width: 1.5rem;
`;

export const ForgetPassword = styled.div`
  margin-top: 30px;
  width: 400px;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  text-decoration-line: underline;
  color: #9aa0ba;
`;

export const Right = styled.div`
  position: relative;
  width: 28.3%;
  img {
    width: 30.1rem;
    height: 100vh;
    position: absolute;
    opacity: 0.7;
    z-index: -1;
    object-fit: cover;
  }
  h2 {
    margin: 0;
    padding: 0;
    font-family: Metropolis;
    font-size: 5em;
    text-align: center;
    color: #fefeff;
    text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
  }
  @media (max-width: 1200px) {
    display: none;
  }
`;

export const Cancel = styled.a`
  margin-top: 2rem;
  font-style: normal;
  font-weight: bold;
  font-size: 1.3rem;
  line-height: 18px;
  text-align: center;
  color: #db3535;
`;
